import React from "react"
import PropTypes from 'prop-types'
import { Bubble, Message, Avatar, withTheme, Markdown as Md } from "../../../../common";
import Suggestions from "../Suggestions";
import Footer from "../Footer";
import { BOTNAME_LABEL } from "../../../../utilities/constants";
import Header from "../Header";
import modules from './response.module.scss';

const Response = (props = {}) => {
    const { className, label: labelText, theme, backgroundColor, accessibleSenderLabel, children, avatar, outline, enableMarkdown, suggestions, handleInput, showFeedback, showHelp, identifier, focus, Markdown, timestamp, ...rest } = props
    const { responseMessage = {}, text = '', type } = theme
    const darkMode = type === 'dark'
    const MarkdownComponent = Markdown ?? Md
    let txt = ''
    if(enableMarkdown && typeof children === 'string') {
        const replacement = ` \n\n  `
        txt = children;
        const possibleIterations = ['<br>', '<br/>', '<br />', ' <br >', '< br>', '< br >']
        possibleIterations.forEach(br => {
            if(txt.includes(br)) {
                txt = txt.replaceAll(br, replacement)
            }
        })
    }

    const label = <Header 
        label={labelText}
        timestamp={timestamp}
        srOnly={" - Response Message"}
    />
        
    return <Message focus={focus} color={text} avatar={avatar || <Avatar className={modules.avatar} darkMode={darkMode} />} className={className} label={label} {...rest}>
        <Bubble focus={focus} color={responseMessage.text} backgroundColor={responseMessage.background} borderColor={responseMessage.border} outline={outline} senderLabel={accessibleSenderLabel}>
            {enableMarkdown ? <MarkdownComponent>{txt ?? children}</MarkdownComponent> : children}
            {suggestions && <Suggestions prefixIdentifier={identifier} handleInput={handleInput} list={suggestions} />}
            {(showFeedback || showHelp) && <Footer divider showFeedback={showFeedback} showHelp={showHelp} handleInput={handleInput} />}
        </Bubble>
    </Message>
}
  

Response.defaultProps = {
    accessibleSenderLabel: `${BOTNAME_LABEL} says`,
    backgroundColor: '',
    className: '',
    enableMarkdown: true,
    handleInput: (value) => console.log(`Message Response, Handle Input:`, value),
    label: BOTNAME_LABEL,
    outline: true,
    suggestions: [],
    theme: { 
        responseMessage: {}
    }
}

Response.propTypes = {
    accessibleSenderLabel: PropTypes.string,
    avatar: PropTypes.element,
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
    enableMarkdown: PropTypes.bool,
    handleInput: PropTypes.func,
    label: PropTypes.string,
    outline: PropTypes.bool,
    suggestions: PropTypes.array
}

export default withTheme(Response)